module.exports = __webpack_public_path__ + "img/ENG-img-01.0623d008.jpg";